module.exports = __webpack_public_path__ + "media/images/lb/064-294b78dd66f23af6090186568aac72a8.svg";